import MainComponent from "components/Main";
import Search from "components/Search";
import ItemClient from "components/ItemClient";

import PropTypes from 'prop-types';

import './index.less';
import './themes/default.less';

export default class SelectClient extends MainComponent {
    static propTypes = {
        onClick: PropTypes.func,
        searchShow: PropTypes.bool,
    };
    static defaultProps = {
        onClick: null,
        searchShow: false,
    };

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            items: [],
            count: 0,
            currentClient: false,
            limit: 4,
        };
    }

    clickItem(it) {
        this.changeState("currentClient", it.id);

        if (this.props.onClick)
            this.props.onClick(it);
    }

    async search() {
        const { limit } = this.state;
        const value = this.input.value;

        if (value.length < 3) {
            this.setState({ items: [], count: 0 });
            return;
        }

        const resp = await this._request.clients.searchByNamePhone(value, limit);

        const items = resp?.data || [];
        const count = resp?.total_count || 0;

        this.setState({ items, count });
    }

    searchWait() {
        clearTimeout(this.searchTimer);
        this.searchTimer = setTimeout(() => {
            clearTimeout(this.searchTimer);
            this.search();
        }, 500);
    }

    removeLimit() {
        this.state.limit = 0;
        this.search();
    }

    set value(value) {
        this.input.value = value;
        this.search();
    }

    get values() {
        const { items } = this.state;
        return items;
    }


    render() {
        const { currentClient, items, count, limit } = this.state;
        const { searchShow } = this.props;

        const cl = count > 4 ? " wide" : "";
        const ds = searchShow ? "" : "none";

        return (
            <div className="selectClient flex col gap16">
                <div style={{ "display": ds }}>
                    <Search
                        ref={el => this.input = el}
                        placeHolder={"main.searchPatient"}
                        onChange={this.searchWait.bind(this)}
                    />
                </div>
                {count > 0 && (
                    <div className={"flex col gap4 rad8 scrolling" + cl}>
                        {items.map((it, i) => {
                            return (
                                <ItemClient
                                    key={i}
                                    info={it}
                                    active={currentClient === it.id ? true : false}
                                    onClick={this.clickItem.bind(this, it)}
                                />
                            );
                        })}
                    </div>
                )}
                {count > 4 && limit > 0 && (
                    <div className="total text p1 flex between">
                        <div>{this.tr("main.total") + ": " + count}</div>
                        <div className="seeAll hand" onClick={this.removeLimit.bind(this)}>
                            {this.tr("main.seeAll")}
                        </div>
                    </div>
                )}
            </div>
        );
    }
}
